<template>
    <div id="confirmemail" class="row page">
        <div class="col-md-6 offset-md-3 p-5 text-center">
            <h1 class="mb-5">Bevestigen van uw email.</h1>
            <loader width="5rem" v-if="isLoading"></loader>
            <div class="alert alert-success" role="alert" v-if="isSuccess">
                <strong>Succes!</strong> Uw emailadres is bevestigd.
            </div>
            <div class="alert alert-danger" role="alert" v-if="isError">
                <strong>Fout!</strong> Helaas konden wij uw email adres niet bevestigen. Neem contact op met Azurity.
            </div>
        </div>
    </div>
</template>

<script>
import Loader from '@/components/Loader';
export default {
    components: {
        'loader': Loader
    },
    data() {
        return {
            isLoading: true,
            isSuccess: false,
            isError: false
        }
    },
    mounted() {
        this.$http.post('api/Auth/ConfirmEmail/' + encodeURIComponent(this.$route.params.userid) + '?token=' + encodeURIComponent(this.$route.query.token))
        .then(() => {
            this.isLoading = false;
            this.isSuccess = true;
        }).catch(() =>
        {
            this.isLoading = false;
            this.isError = true;
        })
    }
}
</script>
